module.exports = __webpack_public_path__ + "img/32.8b59f1c8.png";